<script>
  import { productDataStore } from '../../stores/ProductData';
  import determineProductColourImageUrl from '../../utils/determineProductColourImageUrl';

  import ImagePlaceholder from '../ImagePlaceHolder.svelte';

  export let productRootSlug;
  export let colour;
  export let selected;
  export let gender;
  export let side;
  export let clickFn;

  let imageSrcJpg;
  let imageSrcWebp;
  let isLoading = false;

  async function computeImageSrc(side) {
    const jpgSrc = await determineProductColourImageUrl({
      productSlug: productRootSlug,
      colourPathName: colour.pathName,
      colourObject: colour,
      imageSize: 128,
      imageType: 'jpg',
      gender,
      availableGenders: [colour.mens ? 'mens' : '', colour.womens ? 'womens' : '', colour.youth ? 'youth' : ''],
      side,
      showModel: true,
      isModelBasedImages: $productDataStore[$productDataStore.showing].isModelBasedImages,
      sublimationTemplateId:
        $productDataStore[$productDataStore.showing]?.selectedSublimationTemplate?.SublimationTemplate?.id,
    });

    const webpSrc = await determineProductColourImageUrl({
      productSlug: productRootSlug,
      colourPathName: colour.pathName,
      colourObject: colour,
      imageSize: 128,
      imageType: 'webp',
      gender,
      availableGenders: [colour.mens ? 'mens' : '', colour.womens ? 'womens' : '', colour.youth ? 'youth' : ''],
      side,
      showModel: true,
      isModelBasedImages: $productDataStore[$productDataStore.showing].isModelBasedImages,
      sublimationTemplateId:
        $productDataStore[$productDataStore.showing]?.selectedSublimationTemplate?.SublimationTemplate?.id,
    });

    return { jpgSrc, webpSrc };
  }

  async function updateImage() {
    isLoading = true;
    const { jpgSrc, webpSrc } = await computeImageSrc(side, gender);
    imageSrcJpg = jpgSrc;
    imageSrcWebp = webpSrc;
    isLoading = false;
  }

  $: if (side && gender) {
    updateImage();
  }
</script>

<div class="card-container">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="card"
    on:click={() => {
      clickFn(colour);
    }}
    class:border={selected}
  >
    {#if isLoading}
      <ImagePlaceholder height={'156px'} />
    {:else}
      <picture>
        <source srcset="{imageSrcWebp}, 128w" type="image/webp" />
        <source srcset="{imageSrcJpg}, 128w" type="image/jpeg" />
        <img src={imageSrcJpg} alt={'preview image of ' + colour.displayName} />
      </picture>
    {/if}

    <slot />
    <div class="label">
      {colour.displayName}
    </div>
  </div>
</div>

<style>
  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 1rem;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .card:not(.border):hover {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  img {
    width: 100%;
  }

  .border {
    border: 2px solid #fe5900;
  }

  .label {
    display: flex;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: black;
    text-transform: capitalize;
    width: 100%;
    height: 4rem;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 700px) {
    .label {
      font-size: 1.6rem;
    }
  }
</style>
